// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import {LayoutLeftTop, LayoutLeftBottom, LayoutRightBottom} from 'components/Layout';
import {LocalizedParagraph, Paragraph, useLocalized} from 'components/Localized';
import {IsTouchAgent, IsNonTouchAgent} from 'components/Responsive';
import Image, {BackgroundImage} from 'components/Image';
import Logo from 'components/Logo';
import {addVREventListener, removeVREventListener} from 'utils/vrUtils';
import ButtonIndex from 'components/ButtonIndex';
import Space from 'components/Space';
import SpeedValueBG from 'assets/images/driving-zone/img-top-spedd-bg.svg';
import * as AudioUtils from 'utils/audioUtils';
import * as VRUtils from 'utils/vrUtils';

type Props = {
  isDriving?: boolean,
  isHidden?: boolean,
  items?: Array<boolean>,
  //ecoItems?: Array<boolean>,
  ecoItemCount:number,
  onOpenModalIndex: () => void,
};

const defaultItemEffectDuration = 1.7;
const defaultItemTextEffectDuration = 1.5;


function createEffectHandler(impl, handler?:()=>void ) {
  return function() {
    console.log("eco item effect!");
    impl(true);
    if (handler != null) {
      handler();
    }
    setTimeout(function(){
      if (impl != null) {
        impl(false);
      }
    }, defaultItemEffectDuration * 1000 + 100);
  };
}

function createEffectTextHandler(id, handler?:()=>void) {
  return function() {
    
    if (handler != null) {
      handler();
    }
    
    console.log("text effect!");
    

    let timerId;
    let item = document.getElementById(id);

    if (item != null) {
      item.style.visibility = "";
      //transition: opacity 1s;
      item.style.transitionProperty = "opacity";
      item.style.opacity = "1.0";
      let x = (document.body?.offsetWidth ?? 0) * 0.5;
      let y = (document.body?.offsetHeight ?? 0) * 0.5;
      item.style.transform = "translate(" + x + "px,"+y+"px)";
    }


    function show() {
      let item = document.getElementById(id);
      console.assert(item != null);
      if (item != null) {
        item.style.transitionProperty = "transform, opacity";
      }
      


      function updatePos() {
        if (item == null) {
          return;
        }
        let x = (document.body?.offsetWidth ?? 0) * 0.5;
        let y = (document.body?.offsetHeight ?? 0) * 0.85;
        item.style.transition = "transition: opacity 0.25s, transform 0.5s ease";
        item.style.transform = "translate(" + x + "px,"+y+"px)";
      }

      updatePos();
      if (item != null) {
        timerId = setInterval(updatePos, 100);
      }
    }
    setTimeout(show, 50);


    setTimeout(function(){
      clearInterval(timerId);
      timerId = null;
      let item = document.getElementById(id);
      if (item != null) {
        item.style.opacity = "0.0";
      }
      

    }, defaultItemTextEffectDuration * 1000 + 100);
  };
}

const speedGaugeDummyArray = [null,null,null,null,null,null,null,null,null];

function playItemSound() {
  AudioUtils.play_item();
}
function playSmallItemSound() {
  AudioUtils.play_item(0.5);
}

function playInventorySound() {
  AudioUtils.play_inventory();
}

export default function HeadsUpDisplay(props: Props): React.Element<any> {

  const [left, setLeft0] = React.useState(false);
  const [right, setRight0] = React.useState(false);
  const [drift, setDrift0] = React.useState(false);
  const [ecoEffect, setEcoEffect] = React.useState(false);
  const localized = useLocalized();

  const [GTEffect1, setGTEffect1] = React.useState(false);
  const [GTEffect2, setGTEffect2] = React.useState(false);
  const [GTEffect3, setGTEffect3] = React.useState(false);
  const [GTEffect4, setGTEffect4] = React.useState(false);

  const [showDriftGuide, setShowDriftGuide] = React.useState(false);

  const activateEcoEffect = createEffectHandler(setEcoEffect);
  const activateGTEffect1 = createEffectHandler(setGTEffect1, playInventorySound);
  const activateGTEffect2 = createEffectHandler(setGTEffect2, playInventorySound);
  const activateGTEffect3 = createEffectHandler(setGTEffect3, playInventorySound);
  const activateGTEffect4 = createEffectHandler(setGTEffect4, playInventorySound);



  const activateEcoTextEffect = createEffectTextHandler("item-name-5",playItemSound);
  const activateGTTextEffect1 = createEffectTextHandler("item-name-1",playItemSound);
  const activateGTTextEffect2 = createEffectTextHandler("item-name-2",playItemSound);
  const activateGTTextEffect3 = createEffectTextHandler("item-name-3",playItemSound);
  const activateGTTextEffect4 = createEffectTextHandler("item-name-4",playItemSound);


  React.useEffect(() => {


    

    // for (let i = 1; i <= 5; ++i) {
    //   VRUtils.addVREventListener("fx:item:eco"+i+"Completed", activateEcoEffect );
    //   VRUtils.addVREventListener("fx:item:eco"+i+"Start", activateEcoTextEffect );
    // }
    VRUtils.addVREventListener("fx:item:eco-smallStart", playSmallItemSound );
    VRUtils.addVREventListener("fx:item:ecoCompleted", activateEcoEffect );
    VRUtils.addVREventListener("fx:item:ecoStart", activateEcoTextEffect );

    VRUtils.addVREventListener("fx:item:gt1Start", activateGTTextEffect1 );
    VRUtils.addVREventListener("fx:item:gt2Start", activateGTTextEffect2 );
    VRUtils.addVREventListener("fx:item:gt3Start", activateGTTextEffect3 );
    VRUtils.addVREventListener("fx:item:gt4Start", activateGTTextEffect4 );

    VRUtils.addVREventListener("fx:item:gt1Completed", activateGTEffect1 );
    VRUtils.addVREventListener("fx:item:gt2Completed", activateGTEffect2 );
    VRUtils.addVREventListener("fx:item:gt3Completed", activateGTEffect3 );
    VRUtils.addVREventListener("fx:item:gt4Completed", activateGTEffect4 );


    return function () {
      // for (let i = 1; i <= 5; ++i) {
      //   VRUtils.removeVREventListener("fx:item:eco"+i+"Completed", activateEcoEffect );
      //   VRUtils.removeVREventListener("fx:item:eco"+i+"Start", activateEcoTextEffect );
      // }
      VRUtils.removeVREventListener("fx:item:eco-smallStart", playSmallItemSound );
      VRUtils.removeVREventListener("fx:item:ecoCompleted", activateEcoEffect );
      VRUtils.removeVREventListener("fx:item:ecoStart", activateEcoTextEffect );

      VRUtils.removeVREventListener("fx:item:gt1Start", activateGTTextEffect1 );
      VRUtils.removeVREventListener("fx:item:gt2Start", activateGTTextEffect2 );
      VRUtils.removeVREventListener("fx:item:gt3Start", activateGTTextEffect3 );
      VRUtils.removeVREventListener("fx:item:gt4Start", activateGTTextEffect4 );

      VRUtils.removeVREventListener("fx:item:gt1Completed", activateGTEffect1 );
      VRUtils.removeVREventListener("fx:item:gt2Completed", activateGTEffect2 );
      VRUtils.removeVREventListener("fx:item:gt3Completed", activateGTEffect3 );
      VRUtils.removeVREventListener("fx:item:gt4Completed", activateGTEffect4 );

    };
  });

  React.useEffect(() => {
    VRUtils.ready(() => {
      VRUtils.fireVREvent('car:keydown', 'up');
    });

    return function () {
      VRUtils.ready(() => {});
    };
  });

  const setLeft = React.useCallback((e, flag) => {
    //e.preventDefault();
    setLeft0(flag);

    VRUtils.fireVREvent(flag ? 'car:keydown' : 'car:keyup', 'left');
  }, []);
  const setRight = React.useCallback((e, flag) => {
    //e.preventDefault();
    setRight0(flag);

    VRUtils.fireVREvent(flag ? 'car:keydown' : 'car:keyup', 'right');
  }, []);
  const setDrift = React.useCallback((e, flag) => {
    //e.preventDefault();
    setDrift0(flag);
    VRUtils.fireVREvent(flag ? 'car:keydown' : 'car:keyup', 'drift');
  }, []);
  //guide:drift-pc:show
  //guide:drift-pc:hide
  //showDriftGuide

  React.useEffect(() => {
    function showDriftGuide() {
      setShowDriftGuide(true);
      console.log("driftguide:show");
    }
    function hideDriftGuide() {
      setShowDriftGuide(false);
      console.log("driftguide:hide");
    }

    VRUtils.addVREventListener("guide:drift-pc:show", showDriftGuide );
    VRUtils.addVREventListener("guide:drift-pc:hide", hideDriftGuide );

    return function () {
      VRUtils.removeVREventListener("guide:drift-pc:show", showDriftGuide );
      VRUtils.removeVREventListener("guide:drift-pc:hide", hideDriftGuide );
    };
  }, []);

  return (
    <Wrapper style={{visibility: props.isHidden === true ? 'hidden' : 'visible'}}>
      <WrapperTop>
        <DivLeftSpace />
        {props.isDriving === true && (
          <DivItems source="./driving-zone/img-top-items-bg.png">
            <DivItemTitle id="DivItemTitle" source="./driving-zone/img-top-title-bg.png" localizedText={localized.driving_a01_item_title}>
              {localized.driving_a01_item_title.datatext}
            </DivItemTitle>
            <DivItemWrapper>
              <BackgroundImage id="GTItem1" source="./driving-zone/items-default-1.png" >
                {props.items?.[0] && <GTItemImage source="./driving-zone/items-item-1.png" />}
              </BackgroundImage>
              <BackgroundImage id="GTItem2" source="./driving-zone/items-default-2.png" >
                {props.items?.[1] && <GTItemImage source="./driving-zone/items-item-2.png" />}
              </BackgroundImage>
              <BackgroundImage id="GTItem3" source="./driving-zone/items-default-3.png" >
                {props.items?.[2] && <GTItemImage source="./driving-zone/items-item-3.png" />}
              </BackgroundImage>
              <BackgroundImage id="GTItem4" source="./driving-zone/items-default-4.png" >
                {props.items?.[3] && <GTItemImage source="./driving-zone/items-item-4.png" />}
              </BackgroundImage>
            </DivItemWrapper>
            <DivItemWrapper>
              {props.items?.[0] ? (
                <EffectImage id="GTItemEffect1" source="./driving-zone/items-item-1-effect.png" disabled={!GTEffect1} effect={GTEffect1}  />
              ) : (
                <div id="GTItemEffect1" ></div>
              )}
              {props.items?.[1] ? (
                <EffectImage id="GTItemEffect2" source="./driving-zone/items-item-2-effect.png" disabled={!GTEffect2} effect={GTEffect2}  />
              ) : (
                <div id="GTItemEffect2" ></div>
              )}
              {props.items?.[2] ? (
                <EffectImage id="GTItemEffect3" source="./driving-zone/items-item-3-effect.png" disabled={!GTEffect3} effect={GTEffect3}  />
              ) : (
                <div id="GTItemEffect3" ></div>
              )}
              {props.items?.[3] ? (
                <EffectImage id="GTItemEffect4" source="./driving-zone/items-item-4-effect.png" disabled={!GTEffect4} effect={GTEffect4}  />
              ) : (
                <div id="GTItemEffect4" ></div>
              )}
            </DivItemWrapper>


          </DivItems>
        )}
        {props.isDriving === true && (
          <DivPower source="./driving-zone/img-top-items-bg-2.png">
            <DivPowerTitle id="DivPowerTitle" source="./driving-zone/img-top-title-bg-power.png" localizedText={localized.driving_a01_power_title}>
              {localized.driving_a01_power_title.datatext}
            </DivPowerTitle>
            <DivPowerValue source="./driving-zone/img-top-evpower-bg-2.png">
              <DivPowerValueText0 id="DivPowerValueText0">{ Math.min(100, Math.floor(props.ecoItemCount * 0.91)) } </DivPowerValueText0>
              <DivPowerValueSlash source="./driving-zone/img-eco-line.png" />
              <DivPowerValueText1>100</DivPowerValueText1>
              
            </DivPowerValue>
            <DivSpeedTitle source="./driving-zone/img-top-title-bg-speed.png" localizedText={localized.driving_a01_speed_title}>
              {localized.driving_a01_speed_title.datatext}
            </DivSpeedTitle>
            <DivSpeedValue>
              <DivSpeedValueGaugeParent id="DivSpeedValueGaugeParent">
                {speedGaugeDummyArray.map((value, index) => {
                  return <BackgroundImage source="./driving-zone/img-speed-off.png" key={`${index}`}   />;
                })}
              </DivSpeedValueGaugeParent>

              <DivSpeedValueGaugeParent id="DivSpeedValueGaugeParent">
                {speedGaugeDummyArray.map((value, index) => {
                  const source = "./driving-zone/img-speed-on-"+(index + 1)+".png";
                  return <BackgroundImage source={source} key={`${index}`} id={`speedGauge${index}`}   />;
                })}
              </DivSpeedValueGaugeParent>

              <SpeedGaugeController />
              
            </DivSpeedValue>

            <DivEvcPower id="EcoItem" source="./driving-zone/img-top-evpower-ic.png" />
            <DivEvcPower id="EcoItemEffect" source="./driving-zone/img-top-evpower-ic-effect.png" disabled={!ecoEffect} effect={ecoEffect} />
          </DivPower>
        )}
      </WrapperTop>
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />
      {props.isDriving === true && (
        <IsTouchAgent>
          <ButtonLRWrapper>
            <ButtonLeft
              dataon={left}
              source="./driving-zone/btn-left-off.png"
              onTouchStart={(e) => setLeft(e, true)}
              onTouchEnd={(e) => setLeft(e, false)}
              onTouchCancel={(e) => setLeft(e, false)}>
              <BackgroundImage source="./driving-zone/btn-left-on.png" />
            </ButtonLeft>
            <ButtonRight
              dataon={right}
              source="./driving-zone/btn-right-off.png"
              onTouchStart={(e) => setRight(e, true)}
              onTouchEnd={(e) => setRight(e, false)}
              onTouchCancel={(e) => setRight(e, false)}>
              <BackgroundImage source="./driving-zone/btn-right-on.png" />
            </ButtonRight>
          </ButtonLRWrapper>
          <ButtonDrift
            dataon={drift}
            source="./driving-zone/btn-drift-off.png"
            onTouchStart={(e) => setDrift(e, true)}
            onTouchEnd={(e) => setDrift(e, false)}
            onTouchCancel={(e) => setDrift(e, false)}>
            <BackgroundImage source="./driving-zone/btn-drift-on.png" />
          </ButtonDrift>
        </IsTouchAgent>
      )}
      {props.isDriving === true && (
      <IsNonTouchAgent>
        {showDriftGuide &&
        <React.Fragment>
        <GuideKeyDesktopBase datawidth={undefined} dataheight={64} datax={64} datay={264}>
          <Paragraph textKey="driving_a01_ui4_210313_001" />
          <Image source="./driving-zone/img-key-a-off.png" style={{opacity:0.5}} />
          <Space widthD={10} />
          <Image source="./driving-zone/img-key-s.png" />
          <Space widthD={10} />
          <Image source="./driving-zone/img-key-d-off.png" />
          <Space widthD={74} />
          <Image source="./driving-zone/img-key-space-off.png" style={{opacity:0.5}} />
        </GuideKeyDesktopBase>
        <GuideKeyDesktopBase2 datawidth={undefined} dataheight={64} datax={64} datay={264}>
          <Image source="./driving-zone/img-key-a-on.png" />
          <Space widthD={84} />
          <Space widthD={64} />
          <Space widthD={74} />
          <Image source="./driving-zone/img-key-space-on.png" />
        </GuideKeyDesktopBase2>
        </React.Fragment>}
      </IsNonTouchAgent>
      )}
      {props.isDriving === true && (
      <React.Fragment>
        <ItemName id="item-name-1" style={{visibility: 'hidden'}}><div><LocalizedParagraph {...localized.driving_a01_item_002} /></div></ItemName>
        <ItemName id="item-name-2" style={{visibility: 'hidden'}}><div><LocalizedParagraph {...localized.driving_a01_item_004} /></div></ItemName>
        <ItemName id="item-name-3" style={{visibility: 'hidden'}}><div><LocalizedParagraph {...localized.driving_a01_item_003} /></div></ItemName>
        <ItemName id="item-name-4" style={{visibility: 'hidden'}}><div><LocalizedParagraph {...localized.driving_a01_item_001} /></div></ItemName>
        <ItemName id="item-name-5" style={{visibility: 'hidden'}}><div><LocalizedParagraph {...localized.driving_a01_item_005} /></div></ItemName>
      </React.Fragment>
      )}
      
      <Logo />
    </Wrapper>
  );
}

type PropsSpeedTitle = {
}

function SpeedGaugeController(props: PropsSpeedTitle) {
  const carSpeed = React.useRef(0);
  const timer = React.useRef(null);
  //const [booster, setBooster] = React.useState(false);
  const boosterState = React.useRef(null);

  React.useEffect(() => {

    AudioUtils.play_motor();
    AudioUtils.set_motor_rate(0.0);

    function log_car_speed(speed: number, driftRate: number) {

      // if (window.AudioUtilsData.motor01 == null && speed > 0) {
      //   AudioUtils.play_motor01();
      // }
      // if (window.AudioUtilsData.motor02 == null && speed > 50 && boosterState.current !== true) {
      //   AudioUtils.play_motor02();
      // }
      // if (window.AudioUtilsData.motor02 != null) {
      //   window.AudioUtilsData.motor02.volume( Math.min(speed / 80, 1.0));
      // }
      if (window.AudioUtilsData.motor == null) {
        AudioUtils.play_motor();
      }
      //console.log("speed:", speed);

      AudioUtils.set_motor_rate(speed / AudioUtils.max_speed);//AudioUtils.max_speed * (AudioUtils.max_speed / 150)

      if (!AudioUtils.playing_drift() && driftRate >= 0.01) {
        AudioUtils.play_drift();
      }
      if (AudioUtils.playing_drift() && driftRate < 0.01) {
        AudioUtils.stop_drift();
      }
      if (AudioUtils.playing_drift()) {
        //TODO damp driftRate
        //AudioUtils.set_drift_rate(driftRate / 0.134 );
        AudioUtils.set_drift_rate(driftRate / 0.134 );
      }
      


      

      carSpeed.current = Math.floor(speed);
      //setBooster(speed > 80);
      
    }
    function log_car_boosterStart() {
      //carSpeed.current = "GT ON";
      //setBooster(true);
      boosterState.current = true;
      AudioUtils.play_motorGT();
      //AudioUtils.stop_motor02();

    }
    function log_car_boosterStop() {
      //carSpeed.current = "";
      //setBooster(false);
      boosterState.current = false;
    }

    function handleTime() {
      //setSpeed(carSpeed.current);
      const min = 40;
      const rate = (carSpeed.current - min) / (80 - min) * speedGaugeDummyArray.length;
      for (var i = 0; i < speedGaugeDummyArray.length; ++i) {
        var elm = document.getElementById("speedGauge" + i);
        if (elm == null) {
          continue;
        }
        elm.style.opacity = Math.max(Math.min(1.0, rate - i), 0.0).toString() ;
      }

    }

    addVREventListener('car:speed', log_car_speed);
    addVREventListener('car:boosterStart', log_car_boosterStart);
    addVREventListener('car:boosterStop', log_car_boosterStop);

    timer.current = setInterval(handleTime, 10);

    return () => {
      console.log("audio:stop motor");
      AudioUtils.stop_motor02();
      AudioUtils.stop_motor01();
      AudioUtils.stop_drift();
      AudioUtils.stop_motor();
      removeVREventListener('car:speed', log_car_speed)
      removeVREventListener('car:boosterStart', log_car_boosterStart);
      removeVREventListener('car:boosterStop', log_car_boosterStop);
      if (timer.current) {
        clearInterval(timer.current)
        timer.current = null
      }
    }
  }, []);

  return null;
}


const KeyframesShowShortly = keyframes`
  0% { opacity: 0; }
  20% { opacity: 1; }
  60% { opacity: 1; }
  100% { opacity: 0; }
`;

const KeyframesVisibleDelayed = keyframes`
  0% { opacity: 0; }
  20% { opacity: 0; }
  60% { opacity: 0; }
  100% { opacity: 1; }
`;

const Wrapper = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;

  > * {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }
`;

const WrapperTop = styled(LayoutLeftTop)`
  display: flex;

`;

const DivLeftSpace = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 74 : 260)}px;
  height: ${(props) => (props.theme.layout.mobile ? 40 : 80)}px;
`;

const DivItems = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 325 : 620)}px;
  height: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
  display: inline-block;
  position: relative;
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const DivItemTitle = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 115 : 220)}px;
  height: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
  background-size: 100% 100%;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 0 : 0)}px;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre;

  color: ${(props) => props.localizedText.datacolor};
  font-family: ${(props) => props.localizedText.datafont};
  font-size: ${(props) => props.localizedText.datasize}px;
  line-height: ${(props) => props.localizedText.datalineheight}px;
  text-align: center;
`;


const GTItemImage = styled(BackgroundImage)`
  opacity: 0.0;
  animation: ${(props) => KeyframesVisibleDelayed } 4.5s; 
  animation-fill-mode: forwards;
`;

const EffectImage = styled(BackgroundImage)`
  opacity: ${(props) => (props.disabled ? 0.0 : 1.0)};
  animation: ${(props) => (props.effect ? KeyframesShowShortly : "" ) } 1.5s; 
  animation-fill-mode: forwards;
`;


// left original: 116 : 223
// left modified: 
// original size 26
// modified size 40(@3x=120)
// css size original : 28:54 
// css margin right original : 12:29

const DivItemWrapper = styled.div`
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 116 -7 : 223 -14 )}px;
  top: ${(props) => (props.theme.layout.mobile ? 17 : 23)}px;

  > div {
    margin-right: ${(props) => (props.theme.layout.mobile ? -2 : 1)}px;
    margin-top: -13px;
  }
  div {
    width: ${(props) => (props.theme.layout.mobile ? 42 : 82)}px;
    height: ${(props) => (props.theme.layout.mobile ? 42 : 82)}px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    vertical-align: middle;
    display: inline-block;
  }
`;

const DivPower = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 248 : 478)}px;
  height: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
  margin-left: ${(props) => (props.theme.layout.mobile ? -50 : -100)}px;
  display: inline-block;
  position: relative;
  background-size: 100% 100%;
`;

const DivEvcPower = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 85 : 160)}px;
  height: ${(props) => (props.theme.layout.mobile ? 30 : 60)}px;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;
  top: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;
  opacity: ${(props) => (props.disabled ? 0.0 : 1.0)};
  animation: ${(props) => (props.effect ? KeyframesShowShortly : "" ) } 1.5s; 
  animation-fill-mode: forwards;
  background-size: 100% 100%;
`;

const DivPowerTitle = styled(BackgroundImage)`
  background-size: 100% 100%;
  position: absolute;

  color: ${(props) => props.localizedText.datacolor};
  font-family: ${(props) => props.localizedText.datafont};
  font-size: ${(props) => props.localizedText.datasize}px;
  line-height: ${(props) => props.localizedText.datalineheight}px;
  line-height: ${(props) => (props.theme.layout.mobile ? 16 : 30)}px;
  text-align: center;

  left: ${(props) => (props.theme.layout.mobile ? 80 : 149)}px;
  top: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;
  pointer-events: auto;

  
  width: ${(props) => (props.theme.layout.mobile ? 80 : 137)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 : 30)}px;

`;

const DivPowerValue = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 75 : 130)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 : 24)}px;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 65 : 126)}px;
  top: ${(props) => (props.theme.layout.mobile ? 25 : 50)}px;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

`;
const DivPowerValueText0 = styled.div`
  font-family: kia-bold;
  font-size: ${(props) => (props.theme.layout.mobile ? 9 : 15)}px;
  color: #daff01;
  text-align: right;
  height: ${(props) => (props.theme.layout.mobile ? 9 : 15)}px;
  margin-bottom: ${(props) => (props.theme.layout.mobile ? 2 : 6)}px;
  margin-right: ${(props) => (props.theme.layout.mobile ? 3 : 5)}px;
  width: ${(props) => (props.theme.layout.mobile ? 18: 24)}px;
`;

const DivPowerValueSlash = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 4 : 7)}px;
  height: ${(props) => (props.theme.layout.mobile ? 8 : 13)}px;
  margin-bottom: ${(props) => (props.theme.layout.mobile ? 0 : 1)}px;
`;
const DivPowerValueText1 = styled.div`
  font-family: kia-bold;
  font-size: ${(props) => (props.theme.layout.mobile ? 9 : 15)}px;
  color: #fff;
  text-align: left;
  height: ${(props) => (props.theme.layout.mobile ? 9 : 15)}px;
  margin-left: ${(props) => (props.theme.layout.mobile ? 2 : 3)}px;
  width: ${(props) => (props.theme.layout.mobile ? 12 : 20)}px;
  margin-bottom: ${(props) => (props.theme.layout.mobile ? 2 : 6)}px;
`;



const DivSpeedTitle = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 80 : 147)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 : 30)}px;
  background-size: 100% 100%;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 148 : 269)}px;
  top: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;

  color: ${(props) => props.localizedText.datacolor};
  font-family: ${(props) => props.localizedText.datafont};
  font-size: ${(props) => props.localizedText.datasize}px;
  line-height: ${(props) => props.localizedText.datalineheight}px;
  line-height: ${(props) => (props.theme.layout.mobile ? 16 : 30)}px;
  text-align: center;
  pointer-events: auto;
`;


const DivSpeedValue = styled.div`
  background-image: url(${SpeedValueBG});
  background-size: cover;
  width: ${(props) => (props.theme.layout.mobile ? 80 : 142)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 : 26)}px;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 133 : 243)}px;
  top: ${(props) => (props.theme.layout.mobile ? 25 : 50)}px;
  text-align: center;
  p {
    line-height: ${(props) => (props.theme.layout.mobile ? 15 : 24)}px;
  }


`;

const DivSpeedValueGaugeParent = styled.div`
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  left: ${(props) => (props.theme.layout.mobile ? 4 : 8)}px;
  top: ${(props) => (props.theme.layout.mobile ? -3 : 5)}px;
  > * {
    display: inline-block;
    width: ${(props) => (props.theme.layout.mobile ? 14 : 24)}px;
    height: ${(props) => (props.theme.layout.mobile ? 9 : 16)}px;
    margin-left: ${(props) => (props.theme.layout.mobile ? -8 : -14)}px;
    
  }

`;

const ButtonLRWrapper = styled(LayoutLeftBottom)`
  display: flex;
  flex-direction: row;
`;

const ButtonCommon = styled(BackgroundImage)`
  position: absolute;
  pointer-events: auto;

  div {
    width: 100%;
    height: 100%;
    visibility: ${(props) => (props.dataon ? 'visible' : 'hidden')};

    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

const ButtonLeft = styled(ButtonCommon)`
  position: relative;
  width: 94px;
  height: 90px;
  margin-left: 30px;
  margin-bottom: 30px;
  transform-origin: left bottom;
`;

const ButtonRight = styled(ButtonCommon)`
  position: relative;
  width: 94px;
  height: 90px;
  margin-left: 34px;
  margin-bottom: 30px;
  transform-origin: left bottom;
`;

const ButtonDrift = styled(ButtonCommon)`
  transform: ${(props) => props.theme.layout.scale !== undefined ? `scale(${props.theme.layout.scale})` : 'initial'};
  width: 90px;
  height: 90px;
  right: 30px;
  bottom: 30px;
  transform-origin: right bottom;
`;

const ItemName = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  
  transform-origin: 50% 100%;
  opacity: 0;
  transition-property: opacity, transform;
  transition: opacity 0.35s, transform 0.5s ease;
  > div {
    position: absolute;
    bottom: 0px;
    p {
      width: max-content;
      position: relative;
      left: -50%;
      text-align: center;
    }
  }
`;

const FadeInOut1 = keyframes`
  0% {
    opacity: 0.0;
  }
  50% {
    opacity: 1.0;
  }
  100% {
    opacity: 0.0;
  }
`;


const GuideKeyDesktopBase = styled(LayoutRightBottom)`
  right: 80px;
  bottom: 55px;

  display: flex;

  > p {
    position: absolute;
    right: 0px;
    bottom: 95px;

    width: 100%;
    text-align: center;
  }
`;

const GuideKeyDesktopBase2 = styled(GuideKeyDesktopBase)`
  animation: ${FadeInOut1} 1s;
  animation-iteration-count: infinite;
`;